"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.api = void 0;

var _origin = _interopRequireDefault(require("../lib/origin"));

var _map = _interopRequireDefault(require("./map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BASE_URL = (0, _origin.default)();
var api = {
  iamApi: {
    host: 'https://iam.kubra.io/api/v1'
  }
};
exports.api = api;
var authConfig = {
  clientId: 'PcggvMMnn7EzE9POSiz9CN4XtibvBfD2',
  origin: 'auth0.kubra.io',
  audience: 'https://kubra.io/api',
  silentCallbackPath: "".concat(BASE_URL, "/login/silent-callback"),
  callbackPath: "".concat(BASE_URL, "/login/callback"),
  logoutPath: "".concat(BASE_URL, "/login/logout"),
  responseType: 'token id_token',
  scope: 'openid profile name email',
  useCookies: false
};
var googleAnalyticsCode = 'UA-110840836-3';
var _default = {
  api: api,
  auth: authConfig,
  googleAnalyticsCode: googleAnalyticsCode,
  mapConfig: _map.default
};
exports.default = _default;